<template>
  <div class="vm-banner" :class="[browser_size]">
    <router-link class="banner-door block" to="/album/248b4bb2c9b111e9a9bb52540025c377/92aa33b68b4a11e8aa6952540025c377">
      <img class="block" :src="`${GL.PIC_HOST}/static/img/banner/app-web-banner01.png`" alt />
    </router-link>

    <!-- <router-link v-if="GL.ENV.is_afd_client" class="banner-door block mq mt-32-0" to="/">
      <img class="block" :src="`${GL.PIC_HOST}/static/img/banner/app-web-banner02.png`" alt />
    </router-link>
    <router-link v-else class="banner-door block mq mt-32-0" to="/app">
      <img class="block" :src="`${GL.PIC_HOST}/static/img/banner/app-web-banner03.png`" alt />
    </router-link> -->
    <router-link class="banner-door block mq mt-32-0" to="/a/afdian?tab=shop">
      <img class="block" :src="`${GL.PIC_HOST}/static/img/banner/banner-merch.png`" alt />
    </router-link>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "btn",
  props: {
    text: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      // is_show_banner_1: false,
      // is_show_banner_2: false
    };
  },
  computed: {
    ...mapState("app", ["browser_size"])
  },
  mounted() {},
  methods: {
    // loaded1() {
    //   this.is_show_banner_1 = true;
    // },
    // loaded2() {
    //   this.is_show_banner_2 = true;
    // }
  }
};
</script>

<style lang="stylus" scoped>
.vm-banner {
  .banner-door {
    width: px2rem(200);
    border: 1px solid $black-1;
    // box-shadow: 1px 1px 6px 0 rgba(148, 108, 230, 0.5);
    border-radius: 8px;
    overflow: hidden;
  }

  &.small {
    display: flex;
    padding: 0 px2rem(16);

    .banner-door {
      flex: 1;
      margin-right: px2rem(16);

      &:last-child {
        margin-right: 0;
      }
    }
  }
}
</style>
